// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar-fWz5kNW","button":"button-2cvCzTZ","buttonOn":"buttonOn-oBtZ2JS","label":"label-1WHuSTX","separator":"separator-3LwwnPw"};